import React, {
  useState,
  useEffect
} from "react";

import axios from "axios";

import {
  useNavigate
} from "react-router-dom";

import VisionNavbar from "./VisionNavbar";

import {
  FaFire,
  FaChartLine,
  FaEye,
  FaPlayCircle
} from "react-icons/fa";

import "./MeasureDashboard.css";


const MeasureDashboard = () => {


  /* =====================================================
     HIDE MAIN WEBSITE NAVBAR / FOOTER
  ===================================================== */

  useEffect(() => {

    const navbar =
      document.querySelector(
        "header, .navbar"
      );

    const footer =
      document.querySelector(
        "footer"
      );


    if (navbar)
      navbar.style.display = "none";


    if (footer)
      footer.style.display = "none";


    return () => {

      if (navbar)
        navbar.style.display = "";


      if (footer)
        footer.style.display = "";

    };

  }, []);


  /* =====================================================
     NAVIGATE
  ===================================================== */

  const navigate =
    useNavigate();


  /* =====================================================
     EMAIL
  ===================================================== */

  const email =
    localStorage.getItem(
      "user_email"
    );


  /* =====================================================
     STATES
  ===================================================== */

  const [
    dashboard,
    setDashboard
  ] = useState(null);


  const [
    journey,
    setJourney
  ] = useState(null);


  const [
    loading,
    setLoading
  ] = useState(true);


  const [
    showModal,
    setShowModal
  ] = useState(false);


  /* =====================================================
     FETCH DASHBOARD + JOURNEY
  ===================================================== */

  useEffect(() => {

    if (!email) {

      setLoading(false);

      return;

    }


    fetchData();

  }, [email]);


  /* =====================================================
     FETCH DATA
  ===================================================== */

  const fetchData =
    async () => {

      try {

        setLoading(true);


        const [
          dashboardRes,
          journeyRes
        ] = await Promise.all([

          axios.get(
            `/api/dashboard/${encodeURIComponent(
              email
            )}`
          ),

          axios.get(
            `/api/journey/${encodeURIComponent(
              email
            )}`
          )

        ]);


        /* ==========================
           DASHBOARD
        ========================== */

        setDashboard(
          dashboardRes.data
        );


        /* ==========================
           JOURNEY
        ========================== */

        setJourney(
          journeyRes.data?.journey ||
          journeyRes.data
        );

      }

      catch (err) {

        console.error(
          "Measure Dashboard Error:",
          err
        );

      }

      finally {

        setLoading(false);

      }

    };


  /* =====================================================
     UPDATE ONLY MANUAL LEVEL 1 TASK
     
     Baseline Assessment -> automatic
     Vision Blueprint    -> automatic
     Community Access    -> manual
  ===================================================== */

  const updateLevel1Task =
    async (
      field,
      checked
    ) => {


      /* -----------------------------------------------
         ONLY COMMUNITY ACCESS IS MANUAL
      ----------------------------------------------- */

      if (
        field !==
        "communityJoined"
      ) {

        return;

      }


      try {

        await axios.patch(

          "/api/journey/update",

          {

            email,

            section:
              "level1",

            field,

            value:
              checked

          }

        );


        /* -----------------------------------------------
           REFRESH JOURNEY
        ----------------------------------------------- */

        await fetchData();

      }

      catch (err) {

        console.error(
          "Level 1 task update error:",
          err
        );

      }

    };


  /* =====================================================
     LOADING
  ===================================================== */

  if (loading) {

    return (

      <div className="measure-loading">

        Loading Dashboard...

      </div>

    );

  }


  /* =====================================================
     CURRENT USER LEVEL
  ===================================================== */

  const userLevel =
    Number(
      journey?.currentLevel ||
      dashboard?.currentLevel ||
      dashboard?.level ||
      1
    );


  /* =====================================================
     LEVEL 1 — AWARE
     
     Baseline Assessment -> AUTO
     Vision Blueprint    -> AUTO
     Community Access    -> MANUAL
  ===================================================== */

  const level1Tasks = [

    {

      label:
        "Baseline Assessment",

      completed:
        journey?.level1
          ?.baselineTests === true,

      auto:
        true

    },


    {

      label:
        "Vision Blueprint",

      completed:
        journey?.level1
          ?.visionBlueprint === true,

      auto:
        true

    },


    {

      label:
        "Community Access",

      completed:
        journey?.level1
          ?.communityJoined === true,

      auto:
        false,

      field:
        "communityJoined"

    }

  ];


  /* =====================================================
     LEVEL 1 COUNTS
  ===================================================== */

  const completedTasks =
    level1Tasks.filter(
      task =>
        task.completed
    ).length;


  const totalTasks =
    level1Tasks.length;


  const progressPercent =
    Math.round(

      (
        completedTasks /
        (totalTasks || 1)
      ) * 100

    );


  /* =====================================================
     VISUAL VITALS
  ===================================================== */

  const visualVitals =
    dashboard?.tests || [];


  /* =====================================================
     TEST COMPLETION CHECK
     
     IMPORTANT:
     
     completed === true
       -> Completed
     
     status === completed
       -> Completed
     
     score exists
       -> Completed
     
     score = 0
       -> Completed
     
     score = "-" / empty
       -> Incomplete
     
     completed === false
       -> ALWAYS Incomplete
  ===================================================== */

  const isTestCompleted =
    (test) => {

      /* -----------------------------------------------
         Explicit false means NOT COMPLETED
      ----------------------------------------------- */

      if (
        test?.completed === false
      ) {

        return false;

      }


      /* -----------------------------------------------
         Explicit completed flag
      ----------------------------------------------- */

      if (
        test?.completed === true
      ) {

        return true;

      }


      /* -----------------------------------------------
         Status field
      ----------------------------------------------- */

      if (
        String(
          test?.status || ""
        ).toLowerCase() ===
        "completed"
      ) {

        return true;

      }


      /* -----------------------------------------------
         SCORE CHECK
         
         0 is a valid score.
      ----------------------------------------------- */

      const score =
        test?.score;


      if (
        score !== undefined &&
        score !== null &&
        score !== "" &&
        score !== "-"
      ) {

        return true;

      }


      return false;

    };


  /* =====================================================
     START COURSE
  ===================================================== */

  const handleStartCourse =
    () => {

      window.open(

        "https://learn.forgeyourpeak.in/web/courses",

        "_blank",

        "noopener,noreferrer"

      );

    };


  /* =====================================================
     RENDER
  ===================================================== */

  return (

    <div className="measure-page">


      {/* =================================================
          NAVBAR
      ================================================= */}

      <VisionNavbar
        active="measure"
      />


      {/* =================================================
          MAIN HERO
      ================================================= */}

      <section className="measure-hero">


        {/* =================================================
            LEFT
        ================================================= */}

        <div className="measure-hero-left">


          {/* =================================================
              LEVEL TAG
          ================================================= */}

          


          {/* =================================================
              TITLE
          ================================================= */}

          <h1>

            Vision Ignite

          </h1>


          <p>

            Assess your visual and
            cognitive performance.

          </p>


          {/* =================================================
              LEVEL 1 AWARE CARD
          ================================================= */}

          <div className="measure-level-card">


            {/* =================================================
                CARD HEADER
            ================================================= */}

            <div className="measure-level-header">


              <div>

                <span>

                  CURRENT JOURNEY

                </span>


                <h2>

                  Level 1 — Aware

                </h2>

              </div>


              <div
                className="measure-level-icon"
              >

                <FaEye />

              </div>


            </div>


            {/* =================================================
                LEVEL 1 TASKS
            ================================================= */}

            <div
              className="measure-level-tasks"
            >

              {

                level1Tasks.map(

                  (
                    task,
                    index
                  ) => (

                    <div

                      key={index}

                      className={

                        task.completed

                          ? "measure-task-row task-completed"

                          : "measure-task-row task-pending"

                      }

                    >


                      {/* =================================================
                          AUTOMATIC TASK
                      ================================================= */}

                      {

                        task.auto

                          ?

                          (

                            <span
                              className=
                                "measure-task-status-icon"
                            >

                              {

                                task.completed

                                  ? "✅"

                                  : "⬜"

                              }

                            </span>

                          )

                          :

                          (

                            /* =================================================
                               COMMUNITY ACCESS
                               MANUAL CHECKBOX
                            ================================================= */

                            <input

                              type="checkbox"

                              checked={
                                task.completed
                              }

                              onChange={
                                (e) =>
                                  updateLevel1Task(

                                    task.field,

                                    e.target.checked

                                  )
                              }

                            />

                          )

                      }


                      {/* =================================================
                          TASK NAME
                      ================================================= */}

                      <span>

                        {
                          task.label
                        }

                      </span>


                      {/* =================================================
                          COMPLETED STATUS
                      ================================================= */}

                      {

                        task.completed && (

                          <span
                            className=
                              "measure-task-status"
                          >

                            Completed

                          </span>

                        )

                      }


                    </div>

                  )

                )

              }

            </div>


            {/* =================================================
                PROGRESS
            ================================================= */}

            <div
              className="measure-progress"
            >

              <div
                className=
                  "measure-progress-track"
              >

                <div

                  className=
                    "measure-progress-fill"

                  style={{

                    width:
                      `${progressPercent}%`

                  }}

                />

              </div>


              <div
                className=
                  "measure-progress-footer"
              >

                <span>

                  {completedTasks}
                  /
                  {totalTasks}
                  {" "}
                  Complete

                </span>


                <span>

                  {progressPercent}%

                </span>

              </div>

            </div>


            {/* =================================================
                ACTION BUTTONS
            ================================================= */}

            <div
              className=
                "measure-action-row"
            >


              {/* =================================================
                  START ASSESSMENT
              ================================================= */}

              <button

                className=
                  "measure-start-btn"

                onClick={() =>
                  setShowModal(true)
                }

              >

                <FaPlayCircle />

                START ASSESSMENT

              </button>


              {/* =================================================
                  START COURSE
              ================================================= */}

              <button

                className=
                  "measure-course-btn"

                onClick={
                  handleStartCourse
                }

              >

                <FaPlayCircle />

                START COURSE

              </button>


            </div>


          </div>


        </div>


        {/* =================================================
            RIGHT SIDE
        ================================================= */}

        <div
          className=
            "measure-hero-right"
        >


          {/* =================================================
              CURRENT STREAK
          ================================================= */}

          <div
            className="stat-card"
          >

            <div
              className="stat-icon"
            >

              <FaFire />

            </div>


            <span>

              CURRENT STREAK

            </span>


            <h3>

              {
                dashboard?.dailyStreak ||
                0
              }

            </h3>


            <small>

              Days

            </small>

          </div>


          {/* =================================================
              ASSESSMENTS
          ================================================= */}

          <div
            className="stat-card"
          >

            <div
              className="stat-icon"
            >

              <FaChartLine />

            </div>


            <span>

              ASSESSMENTS

            </span>


            <h3>

              {
                dashboard?.totalTestsCompleted ||
                dashboard?.totalAssessments ||
                0
              }

            </h3>


            <small>

              Completed

            </small>

          </div>


        </div>


      </section>


      {/* =====================================================
          VISUAL VITALS
      ===================================================== */}

      <section
        className="visual-vitals"
      >


        <div
          className="section-header"
        >

          <h2>

            Visual Vitals

          </h2>


          <p>

            Latest assessment results
            across your vision and
            cognitive tests.

          </p>

        </div>


        <div
          className="vitals-grid"
        >


          {

            visualVitals.length > 0

              ?

              visualVitals.map(

                (
                  test,
                  index
                ) => {

                  /* ==========================================
                     CHECK TEST STATUS
                  ========================================== */

                  const completed =
                    isTestCompleted(
                      test
                    );


                  return (

                    <div

                      key={
                        test._id ||
                        test.id ||
                        index
                      }

                      className=
                        "vital-card"

                    >


                      {/* ======================================
                          TEST NAME
                      ====================================== */}

                      <div
                        className=
                          "vital-top"
                      >

                        <span
                          className=
                            "vital-name"
                        >

                          {
                            test.name ||
                            "Assessment"
                          }

                        </span>

                      </div>


                      {/* ======================================
                          SCORE
                      ====================================== */}

                      <div
                        className=
                          "vital-score"
                      >

                        {

                          test.score !==
                            undefined &&

                          test.score !==
                            null &&

                          test.score !== ""

                            ?

                            test.score

                            :

                            "-"

                        }

                      </div>


                      {/* ======================================
                          STATUS
                      ====================================== */}

                      <div

                        className={

                          completed

                            ? "vital-status"

                            : "vital-status vital-status-incomplete"

                        }

                      >

                        {

                          completed

                            ? "Completed"

                            : "Incomplete"

                        }

                      </div>


                    </div>

                  );

                }

              )

              :

              (

                <div
                  className=
                    "vitals-empty"
                >

                  <p>

                    Complete your first
                    assessment to see
                    your results here.

                  </p>

                </div>

              )

          }


        </div>


      </section>


      {/* =====================================================
          ASSESSMENT MODAL
      ===================================================== */}

      {

        showModal && (

          <div

            className=
              "assessment-modal-overlay"

            onClick={() =>
              setShowModal(false)
            }

          >


            <div

              className=
                "assessment-modal"

              onClick={
                (e) =>
                  e.stopPropagation()
              }

            >


              {/* ==========================================
                  MODAL HEADER
              ========================================== */}

              <div
                className=
                  "modal-header"
              >

                <div>

                  <h2>

                    Choose Assessment

                  </h2>


                  <p>

                    Select a test to begin
                    your assessment.

                  </p>

                </div>


                <button

                  className=
                    "close-modal"

                  onClick={() =>
                    setShowModal(false)
                  }

                >

                  ×

                </button>

              </div>


              {/* ==========================================
                  ASSESSMENT GRID
              ========================================== */}

              <div
                className=
                  "assessment-grid"
              >


                <div

                  className=
                    "assessment-item"

                  onClick={() =>
                    navigate(
                      "/visual-acuity"
                    )
                  }

                >

                  👁️ Visual Acuity

                </div>


                <div

                  className=
                    "assessment-item"

                  onClick={() =>
                    navigate(
                      "/color-vision"
                    )
                  }

                >

                  🎨 Color Vision

                </div>


                <div

                  className=
                    "assessment-item"

                  onClick={() =>
                    navigate(
                      "/contrast"
                    )
                  }

                >

                  ⚫ Contrast Sensitivity

                </div>


                <div

                  className=
                    "assessment-item"

                  onClick={() =>
                    navigate(
                      "/reactiongame"
                    )
                  }

                >

                  ⚡ Reaction Speed

                </div>


                <div

                  className=
                    "assessment-item"

                  onClick={() =>
                    navigate(
                      "/complex-reaction"
                    )
                  }

                >

                  🚀 Complex Reaction

                </div>


                <div

                  className=
                    "assessment-item"

                  onClick={() =>
                    navigate(
                      "/short-term-memory"
                    )
                  }

                >

                  🧠 Short Term Memory

                </div>


                <div

                  className=
                    "assessment-item"

                  onClick={() =>
                    navigate(
                      "/working-memory"
                    )
                  }

                >

                  📚 Working Memory

                </div>


                <div

                  className=
                    "assessment-item"

                  onClick={() =>
                    navigate(
                      "/search-span"
                    )
                  }

                >

                  🔍 Search Span

                </div>


                <div

                  className=
                    "assessment-item"

                  onClick={() =>
                    navigate(
                      "/anticipation"
                    )
                  }

                >

                  🎯 Anticipation

                </div>


              </div>


            </div>

          </div>

        )

      }


    </div>

  );

};


export default MeasureDashboard;